import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PromptService {
  prompts: any;
  languages: any;
  public version: any;

  setLanguage(lang: any) {
    this.prompts = this.languages[lang];

    if (!this.prompts) {
      this.prompts = this.languages.english;
    }
  }
  constructor() {
    this.languages = {};
    this.version = environment.version;

    this.languages.english = {
      version: 'Version: ' + this.version + ' {build 0.0.2308}',
    };
    this.languages.chinese = {
      version: '版本: ' + this.version + ' {build 0.0.2308}',
    };

    this.prompts = this.languages.english;
  }
}
